$(function () {
  /* tag_navの開閉 */
  $('.js_tag_nav_search').on('click', function () {
    $('#tag_nav').addClass('tag_nav_open');
  });
  $('.js_tag_nav_close').on('click', function () {
    $('#tag_nav').removeClass('tag_nav_open');
  });

  let categoryName = '';
  let tagName = '';
  $('input[name="category"]').on('change', function () {
    categoryName = $(this).attr('value');
  });
  $('input[name="tag"]').on('change', function () {
    tagName = $(this).attr('value');
  });

  let searchDirectory;
  const domain = 'https://bonsai-plus-test.myshopify.com';
  $('#search_btn').on('click', function () {
    if (categoryName === '' && tagName === '') {
      searchDirectory = '/collections/all/';
    } else if (categoryName === '') {
      searchDirectory = '/collections/all/' + tagName;
    } else if (tagName === '') {
      searchDirectory = '/collections/all?q=' + categoryName;
    } else {
      searchDirectory = '/collections/types?constraint=' + tagName + '&q=' + categoryName;
    }
    window.location.href = domain + searchDirectory;
  });
});
